export default {
  data() {
    return {
      formLinkWorkRequest: {
        adid: "", // asset detail
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        epdid: "", // test program detail
        epid: "",
        ept: "",
        eprev: "",
        wpdid: "", // work procedure detail
        wpid: "",
        wpt: "",
        wprev: "",
        bdid: "", // budget detail
        bid: "",
        bt: "",
        pdid: "", // plan detail
        pid: "",
        pt: "",
        padd: "" // item addeded to plan
      },
      formLinkWorkCall: {
        adid: "", // asset
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        fdid: "", // facility
        fid: "",
        ft: "",
        epdid: "", // eng. test program
        epid: "",
        ept: "",
        eprev: "",
        wpdid: "", // work procedure
        wpid: "",
        wpt: "",
        wprev: "",
        bbdid: "", // budget
        bbid: "",
        bbt: "",
        bpdid: "", // plan
        bpid: "",
        bpt: "",
        pdid: "", // plan detail
        pid: "",
        pt: "",
        padd: "", // item addeded to plan
        mpdid: "", // work procedure
        mpid: "",
        mpt: ""
      },
      formLinkEngineeringRequest: {
        adid: "", // asset
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        fdid: "", // facility
        fid: "",
        ft: "",
        ftag: "",
        mdid: "", // material
        mid: "",
        midg: "",
        mt: "",
        mtag: "",
        edid: "", // equipmeng
        eid: "",
        eidg: "",
        et: "",
        etag: "",
        bdid: "", // budget
        bid: "",
        bidg: "",
        bt: "",
        btag: "",
        pdid: "", // plan
        pid: "",
        pidg: "",
        pt: "",
        ptag: "",
        sdid: "", // source document if applicable
        sid: "",
        sidg: "",
        st: "",
        stag: ""
      },
      formLinkReport: {
        adid: "", // asset, which asset it belongs to
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        epdid: "", // eng. test program
        epidg: "",
        ept: "",
        eprev: "",
        epid: "",
        edid: "", // equipment to enable sorting.
        eid: "",
        eidg: "",
        et: "",
        etag: "",
        sdid: "", // source document if applicable (example work request)
        sid: "",
        sidg: "",
        st: "",
        stag: ""
      },
      formLinkGeneralAssetFacility: {
        adid: "", // asset
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        fdid: "", // facility
        fid: "",
        fidg: "",
        ft: ""
      },
      formLinkGeneralAssetFacilityCompany: {
        adid: "", // asset
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        fdid: "", // facility
        fid: "",
        fidg: "",
        ft: "",
        cdid: "", // used for actions where action orgin is not always
        cid: "", // company sign in from pref.select of user
        cidg: "",
        ct: ""
      },
      formLinkGeneralSourceAssetFacilityCompany: {
        adid: "", // asset
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        fdid: "", // facility
        fid: "",
        fidg: "",
        ft: "",
        cdid: "", // used for actions where action orgin is not always
        cid: "", // company sign in from pref.select of user
        cidg: "",
        ct: "",
        sdid: "", // source document
        sid: "",
        sidg: "",
        st: "",
        stag: ""
      },
      formLinkFacility: {
        fdid: "", // facility did
        fid: "", // facility id
        fidg: "", // facility idg
        ft: "", // facility title
        ftag: "" // facility tag
      },
      formLinkFacilityEquipment: {
        fdid: "", // facility did
        fid: "", // facility id
        fidg: "", // facility idg
        ft: "", // facility title
        ftag: "", // equipment tag
        edid: "", // eacility did
        eid: "", // eacility id
        eidg: "", // eacility idg
        et: "", // eacility title
        etag: "" // facility tag
      },
      formLinkFacilityEquipmentBudget: {
        fdid: "", // facility did
        fid: "", // facility id
        fidg: "", // facility idg
        ft: "", // facility title
        ftag: "", // equipment tag
        edid: "", // eacility did
        eid: "", // eacility id
        eidg: "", // eacility idg
        et: "", // eacility title
        btag: "", // budget tag
        bdid: "", // bacility did
        bid: "", // bacility id
        bidg: "", // bacility idg
        bt: "" // bacility titlb
      },
      formLinkFacilitySourceBudget: {
        fdid: "", // facility did
        fid: "", // facility id
        fidg: "", // facility idg
        ft: "", // facility title
        ftag: "", // equipment tag
        sdid: "", // facility did
        sid: "", // facility id
        sidg: "", // facility idg
        st: "", // facility title
        btag: "", // budget tag
        bdid: "", // bacility did
        bid: "", // bacility id
        bidg: "", // bacility idg
        bt: "" // bacility titlb
      },
      formLinkFacilityPlan: {
        fdid: "", // facility
        fid: "",
        fidg: "",
        ft: "",
        pdid: "", // plan detail
        pid: "",
        pidg: "",
        pt: "",
        ptag: ""
      },
      formLinkFacilityBudget: {
        fdid: "", // facility
        fid: "",
        fidg: "",
        ft: "",
        bdid: "", // plan detail
        bid: "",
        bidg: "",
        bt: "",
        btag: ""
      },
      formLinkPlanBudgetRisk: {
        bdid: "", // plan detail
        bid: "",
        bidg: "",
        bt: "",
        btag: "",
        pdid: "", // plan detail
        pid: "",
        pidg: "",
        pt: "",
        ptag: "",
        rdid: "", // risk detail
        rid: "",
        ridg: "",
        rt: "",
        rtag: ""
      },
      formLinkEquipmentRisk: {
        edid: "", // equipment detail
        eid: "",
        eidg: "",
        et: "",
        etag: "",
        rdid: "", // risk detail
        rid: "",
        ridg: "",
        rt: "",
        rtag: ""
      },
      formLinkAssetEquipmentRisk: {
        adid: "", // asset detail
        aid: "",
        aidg: "",
        at: "",
        atag: "",
        edid: "", // equipment detail
        eid: "",
        eidg: "",
        et: "",
        etag: "",
        rdid: "", // risk detail
        rid: "",
        ridg: "",
        rt: "",
        rtag: ""
      },
      formLinkAsset: {
        adid: "", // asset detail
        aid: "",
        aidg: "",
        at: "",
        atag: ""
      },
      formLinkGeneralAssetFacilitySource: {
        adid: "", // asset
        aid: "",
        at: "",
        asys: "",
        aunit: "",
        amap: "",
        agrid: "",
        fdid: "", // facility
        fid: "",
        fidg: "",
        ft: "",
        sdid: "", // source doc did
        sid: "", // source id
        sidg: "", // source id
        stag: "", // source document tag
        st: "" // source title
      },
      formLinkMaintPlan: {
        epdid: "", // eng. test program
        epid: "",
        epidg: "",
        ept: "",
        eprev: "",
        wpdid: "", // work procedure
        wpid: "",
        wpidg: "",
        wpt: "",
        wprev: "",
        bdid: "", // budget
        bid: "",
        bidg: "",
        bt: "",
        pdid: "", // plan
        pid: "",
        pidg: "",
        pt: "",
        madid: "", // maintenance activity
        maid: "",
        maidg: "",
        mat: "",
        msdid: "", // maintenance strategy
        msid: "",
        msidg: "",
        mst: "",
        mcdid: "", // maintenance call
        mcid: "",
        mcidg: "",
        mct: ""
      },
      formLinkMaintCall: {
        epdid: "", // eng. test program
        epid: "",
        epidg: "",
        ept: "",
        eprev: "",
        wpdid: "", // work procedure
        wpid: "",
        wpidg: "",
        wpt: "",
        wprev: "",
        bdid: "", // budget plan
        bid: "",
        bidg: "",
        bt: "",
        pdid: "", // business plan
        pid: "",
        pidg: "",
        pt: "",
        madid: "", // maintenance activity
        maid: "",
        maidg: "",
        mat: "",
        msdid: "", // maintenance strategy
        msid: "",
        msidg: "",
        mst: "",
        mpdid: "", // maintenance plan
        mpid: "",
        mpidg: "",
        mpt: ""
      }
    };
  }
};
